import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import cloneDeep from 'lodash/cloneDeep';
import PictureColorPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/picture-color-preset-menu';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { isImageButNotAttachment, isImageOrImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';

const defaultPictureCorrectionsProps = {
    saturate: 100,
    colorTemperature: 6500,
};

@Feature()
export class PictureColorFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    private currentProps;

    public renderMenu() {
        const model = this.getFirstPictureModel();
        if (!model) {
            return null;
        }
        const {
            saturate,
            colorTemperature,
            grayscl,
            duotone,
            biLevel,
            luminance,
        } = cloneDeep(model.props.style.image) || {};
        this.currentProps = { saturate, colorTemperature, grayscl, duotone, biLevel, luminance };
        const hidePreset = this.shouldHide();
        return <PictureColorPresetMenu
            displaySaturate={!hidePreset}
            displayColorTemperature={!hidePreset}
            displayRecolor={!this.includeGif()}
            selectedElementModel={model}
            pictureProps={model.props}
            onPresetStyleClick={this.handlePresetStyleClick}
            onPresetStyleMouseEnter={this.handlePresetStyleMouseEnter}
            onPresetStyleMouseLeave={this.handlePresetStyleMouseLeave}
        />;
    }

    public shouldDisabled = () => {
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        const pictureModels = models.filter(isImageButNotAttachment);
        return !pictureModels.length || isPreviewOnly();
    };

    private shouldHide(): boolean {
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        const pictureModels = models.filter(isImageOrImageFillShape);
        return pictureModels.length !== 1;
    }

    private getFirstPictureModel(): IPictureModel {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return selectedModels.find(isImageOrImageFillShape) as IPictureModel;
    }

    private getPictureModels() {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return selectedModels.filter(isImageOrImageFillShape);
    }

    private includeGif() {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return !!selectedModels.filter(item => isImageOrImageFillShape(item) && (item as IPictureModel).props?.imageType === 'gif').length;
    }

    private handlePresetStyleMouseEnter = (props) => {
        const updateProps = { ...props };
        this.getToolbarMenu()?.callback('', ActionType.PICTURE_COLOR, updateProps, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleMouseLeave = () => {
        this.getToolbarMenu()?.callback('', ActionType.PICTURE_COLOR, this.currentProps, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleClick = (props) => {
        const updateProps = { ...props };
        this.getToolbarMenu()?.callback('', ActionType.PICTURE_COLOR, updateProps, { onlyChangeUI: false, onlyPreview: false });
    };
}
